/* Behavior - behaviors/scroll-page.js */

$(window).on('load', function() {
    var urlArray = window.location.pathname.split('/');
    var urlPath = urlArray[urlArray.length - 1].toLowerCase();

    if($(window).innerWidth() < 992 && urlPath != 'index.php' && urlPath != '') {
        $('body, html').animate({
            scrollTop: $('main').offset().top - 30
        }, 600);
    }
});